/**
 * Current Time Line
 *
 * Red horizontal line indicating the current time, updates every minute.
 */

import { useState, useEffect } from 'react';
import {
  PIXELS_PER_MS,
  DEFAULT_START_HOUR,
} from '@/utils/scheduleLayout';

interface CurrentTimeLineProps {
  dayDate: Date;
  startHour?: number;
}

export function CurrentTimeLine({
  dayDate,
  startHour = DEFAULT_START_HOUR,
}: CurrentTimeLineProps) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(interval);
  }, []);

  // Only show if today
  const today = new Date();
  const isToday =
    dayDate.getFullYear() === today.getFullYear() &&
    dayDate.getMonth() === today.getMonth() &&
    dayDate.getDate() === today.getDate();

  if (!isToday) return null;

  const dayStart = new Date(dayDate);
  dayStart.setHours(startHour, 0, 0, 0);
  const dayStartMs = dayStart.getTime();

  const top = (now - dayStartMs) * PIXELS_PER_MS;

  if (top < 0) return null;

  return (
    <div
      className="absolute left-0 right-0 z-20 pointer-events-none"
      style={{ top: `${top}px` }}
    >
      <div className="relative flex items-center">
        <div className="w-2 h-2 rounded-full bg-accent-rose -ml-1 shrink-0" />
        <div className="flex-1 h-[2px] bg-accent-rose" />
      </div>
    </div>
  );
}
